// date
import {isDate} from 'date-fns';

export default (date) =>
  `${(isDate(date) ? date : new Date(date)).toISOString().split('.')[0]}Z`;
